import React, { useState } from 'react'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import './CustomerAccountTabs.scss'

import { isMobile, isDesktop, isIpad } from '../../global/ScreenSizeHelper'

const CustomerAccountTabs = (props) => {

    const { customerAcctTabNames, setTabValue, tabValue } = props

    //const [activeCustAcctTab, setActiveCustAcctTab] = useState(tabNames[0])




    const handleChange = (event, newValue) => {
        setTabValue(newValue)
    };



    return (
        <Tabs
            value={tabValue || ''}
            onChange={handleChange}
            textColor="secondary"
            indicatorColor="secondary"
            aria-label="Vertical tabs example"
            variant="scrollable"
            scrollButtons={false}
            allowScrollButtonsMobile
            className='menu-tabs-container'
            orientation="vertical"
        >
            {
                customerAcctTabNames.map((tab) => {
                    return (<Tab sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', wordWrap: 'break-word' }} value={tab} label={tab} key={tab} />)

                })
            }

        </Tabs>
    )
}

export default CustomerAccountTabs